module.exports = __webpack_public_path__ + "static/media/gordon-sandford.5c01b4b4.jpg";